import { hasBrandLogo, resolveBrandChain } from './brand';
import { isCityCode } from './city-catalog';
import { eventVenueRequirementViolation } from './event-venue';
import { venueGeoRequirementViolation } from './venue-geo';
import { isoToWallClock, wallClockToIso } from './wall-clock';
/**
 * ETKİNLİK KURULUMUNUN (panel · `manage/kurulum`) ORTAK KURALLARI.
 *
 * `packages/shared` ALTINDADIR çünkü AYNI dört adım iki istemcide yaşıyor:
 * web (`manage-setup.tsx`) ve mobil (`ManageSetupSection.tsx`). Dosya Tur T7
 * öncesinde `apps/web/src/features/events/ui/manage/manage-setup-checks.ts`
 * idi; TAŞINDI, kopyalanmadı — CLAUDE.md: "web ve mobil arasında çoğaltılan iş
 * mantığı `packages/shared`'a taşınır".
 *
 * OLUŞTURMA SİHİRBAZIYLA KARIŞTIRILMAZ (`event-draft.ts`): o altı adımda YENİ
 * etkinlik doğurur ve `CreateEventInput` kurar; bu dört adım VAR OLAN etkinliği
 * düzenler ve `UpdateEventPatch` kurar. İki taslak aynı şey olsaydı tek tip
 * yeterdi; değiller (kurum seçimi, bilet satırı ve etiketler burada YOK).
 */
export const SETUP_TOTAL_STEPS = 4;
export const SETUP_STEP_INDEXES = [1, 2, 3, 4];
/**
 * ADIM ŞERİDİNİN ETİKETLERİ — anahtarlar AÇIKÇA listelenir. Dizgeden anahtar
 * üretmek (`organizer.setup.step${n}`) `TranslationKey` tipini devre dışı
 * bırakır ve eksik çeviri derlemeden kaçardı.
 */
const SETUP_STEP_TITLE_KEYS = {
    1: 'organizer.setup.step1',
    2: 'organizer.setup.step2',
    3: 'organizer.setup.step3',
    4: 'organizer.setup.step4',
};
export function setupStepTitleKey(step) {
    return SETUP_STEP_TITLE_KEYS[step];
}
/** Sınırı aşmayan adım — derin bağlantı ve diskten dönen taslak için. */
export function clampSetupStep(value) {
    const step = Math.trunc(value);
    return SETUP_STEP_INDEXES.find((index) => index === step) ?? 1;
}
/**
 * Künyeden forma. Tarihler ETKİNLİĞİN dilimindeki duvar saatine çevrilir;
 * kullanıcı kendi cihazının dilimini değil etkinliğin saatini düzenler.
 */
export function setupDraftFromEvent(event) {
    return {
        title: event.title,
        summary: event.summary ?? '',
        description: event.description ?? '',
        venueName: event.venue.name ?? '',
        venueAddressLine: event.venue.addressLine ?? '',
        venueCityCode: event.venue.cityCode ?? '',
        onlineUrl: event.onlineUrl ?? '',
        websiteUrl: event.websiteUrl ?? '',
        capacity: event.capacity === null ? '' : String(event.capacity),
        startsAt: isoToWallClock(event.startsAt, event.timezone),
        endsAt: isoToWallClock(event.endsAt, event.timezone),
    };
}
/**
 * Formdan gövdeye.
 *
 * ALT NESNE TAM GİDER (QA Blok 30 · BULGU-1): sunucu `venue` gelince beş
 * kolonu da yazar; yalnız `name` göndermek şehri düşürüp künyeyi kaydedilemez
 * kılıyordu. Ekranın değiştirmediği alanlar künyeden taşınır. Sınıf
 * `packages/shared/src/contracts/subobject-patch.guard.spec.ts` ile enumere.
 *
 * ŞEHİR YALNIZ YÜZ YÜZE VE HİBRİTTE GİDER (B-26/4): çevrimiçi etkinlikte alan
 * çizilmez, künyedeki değer taşınır. Boş ya da katalog dışı değer `null` gider
 * ve sunucu zorunluluğu (`event.venueCityRequired`) alanın altına yazdırır.
 *
 * BAĞLANTI YALNIZ ÇEVRİMİÇİ VE HİBRİTTE GİDER (Tur V3): yüz yüze etkinlikte
 * alan çizilmez, yama da ona dokunmaz. Boşaltılan bağlantı `null` gider ve
 * sunucu zorunluluğu (`event.onlineUrlRequired`) alanın altına yazdırır.
 *
 * HARİTADAKİ KONUM (harita Story 4) taslağın METİN alanlarından ayrı gelir:
 * yalnız "Haritada bul" sonucundan seçilir, elle yazılmaz. `venueGeo` verilmezse
 * (konumu toplamayan istemci) yama künyedeki konumu taşır; `null` = konum
 * kaldırıldı ya da adres değişti.
 *
 * KAPAK (kullanıcı kararı 02.11.2026, mobil kurulum Adım 1) metin taslağından
 * ayrı gelir ve marka taslağıyla aynı üç değerli anlamı taşır: verilmezse
 * (`undefined`, kapağa dokunulmadı ya da kapağı toplamayan istemci) yama
 * `coverMediaId`e DOKUNMAZ; `null` = kapak kaldırıldı; dizge = yeni kapak.
 */
export function buildSetupPatch(draft, event, venueGeo, coverMediaId) {
    return {
        ...(coverMediaId !== undefined ? { coverMediaId } : {}),
        title: draft.title.trim(),
        summary: draft.summary.trim() || null,
        description: draft.description.trim() || null,
        venue: {
            ...event.venue,
            name: draft.venueName.trim() || null,
            addressLine: draft.venueAddressLine.trim() || null,
            ...(venueGeo !== undefined ? { geo: venueGeo } : {}),
            ...(event.format !== 'online'
                ? { cityCode: isCityCode(draft.venueCityCode) ? draft.venueCityCode : null }
                : {}),
        },
        ...(event.format !== 'in_person' ? { onlineUrl: draft.onlineUrl.trim() || null } : {}),
        websiteUrl: draft.websiteUrl.trim() || null,
        capacity: draft.capacity.trim() ? Number(draft.capacity) : null,
        ...(draft.startsAt ? { startsAt: wallClockToIso(draft.startsAt, event.timezone) } : {}),
        ...(draft.endsAt ? { endsAt: wallClockToIso(draft.endsAt, event.timezone) } : {}),
    };
}
/**
 * "Temel bilgiler tamam mı" — kontrol listesinin ilk satırının ve yayın
 * kapısının kararı.
 *
 * MEKÂN KURALI TEK KAYNAKTAN OKUNUR (`eventVenueRequirementViolation`), elle
 * tekrar yazılmaz. Web'deki eski kopya `online` etkinlikte de `venue.name`
 * arıyordu; sunucu aramıyor (mekân yok), yani çevrimiçi etkinlik kontrol
 * listesinde HİÇ "tamam" olamıyordu. Taşıma sırasında kural kaynağa bağlandı.
 */
export function setupBasicsOk(event, switches) {
    return setupPublishBlockers(event, switches).length === 0;
}
/**
 * YAYIN İÇİN EKSİK OLAN ALANLAR — etiket anahtarlarıyla (Tur T7 · kriter 4).
 *
 * Kapı İKİ AYAKLIDIR (md. 1c): liste doluyken "Yayınla" kapalıdır VE eksiğin
 * ADI ekranda yazılıdır; liste boşalınca düğme AÇILIR. "Yayınlanamıyor" deyip
 * nedenini söylememek bu projede defalarca çıkmış bir kusur sınıfıdır.
 *
 * Liste YALNIZ GERÇEKTEN ENGELLEYENİ taşır. Bilet, ajanda, marka ve kurum
 * doğrulama satırları kontrol listesinde UYARIDIR ve yayını durdurmaz
 * (referans: "Eksik olan maddeler yayını engellemez ama public sayfada boş
 * görünür").
 */
/**
 * `switches` (harita, bölüm 11 madde 1): sunucunun herkese açık harita
 * anahtarları. Verilirse konum zorunluluğu da sayılır; verilmezse (anahtarı
 * okumayan istemci) kural eskisi gibidir ve son kararı sunucu verir.
 */
export function setupPublishBlockers(event, switches) {
    const missing = [];
    if (!event.title)
        missing.push('organizer.setup.titleLabel');
    if (!event.startsAt)
        missing.push('organizer.setup.startsAtLabel');
    if (!event.endsAt)
        missing.push('organizer.setup.endsAtLabel');
    const venue = eventVenueRequirementViolation(event.format, event.venue.name, event.venue.addressLine);
    if (venue?.path === 'venue.name')
        missing.push('organizer.setup.venueLabel');
    if (venue?.path === 'venue.addressLine')
        missing.push('organizer.setup.venueAddressLabel');
    if (switches && venueGeoRequirementViolation(event.format, event.venue.geo, switches)) {
        missing.push('venueMap.fieldLabel');
    }
    return missing;
}
/**
 * SUNUCUNUN ALAN HATASI HANGİ ADIMDA DÜZELTİLİR (Tur T7 · kabul kriteri 5).
 *
 * Dört adım TEK ekranda yer değiştirdiği için "Etkinlik adı en az 12 karakter"
 * cümlesi 4. adımdayken yazılırsa kullanıcı düzeltilecek alanı GÖREMEZ ve
 * ekran ona jenerik bir "bir şeyler ters gitti" duygusu verir. Yol → adım
 * eşlemesi BURADA, tek yerde durur; iki istemci de aynı adıma götürür.
 *
 * Eşleşmeyen yol `null` döner: uydurma bir adıma atlamak, yanlış alanı
 * göstermekten beterdir (md. 9).
 */
const SETUP_FIELD_STEPS = {
    title: 1,
    summary: 1,
    description: 1,
    startsAt: 1,
    endsAt: 1,
    timezone: 1,
    format: 1,
    onlineUrl: 1,
    websiteUrl: 1,
    capacity: 1,
    'venue.name': 1,
    'venue.addressLine': 1,
    'venue.cityCode': 1,
    'venue.countryCode': 1,
    'venue.geo': 1,
    accessMode: 2,
};
export function setupStepOfPath(path) {
    return SETUP_FIELD_STEPS[path] ?? null;
}
/** Künye formunun sunucuya bildirdiği alan yolları (satır içi hata yüzeyi). */
export const SETUP_BASICS_ERROR_PATHS = Object.keys(SETUP_FIELD_STEPS).filter((path) => SETUP_FIELD_STEPS[path] === 1);
/**
 * Zincirin panel tarafındaki TEK çağrısı. Bölüm bileşeni halkaları elle
 * dizmez — `resolveBrandChain` burada, tek yerde çağrılır (P11).
 */
export function resolveSetupBrand(event, organization, 
/** Platform halkası — çağıran env'den taşır (ORTA-3). */
platform) {
    return resolveBrandChain({
        platform,
        event: {
            logoMediaId: event.brandLogoMediaId,
            logoUrl: event.brandLogoUrl,
            color: event.brandColor,
        },
        organization: organization
            ? {
                logoMediaId: organization.logoMediaId,
                logoUrl: organization.logoUrl,
                color: organization.brandColor,
            }
            : null,
    });
}
export function buildSetupChecks(input) {
    const brandOk = input.brand !== null && hasBrandLogo(input.brand);
    return [
        {
            labelKey: 'organizer.setup.checkBasics',
            bodyKey: input.basicsOk
                ? 'organizer.setup.checkBasicsOk'
                : 'organizer.setup.checkBasicsMissing',
            ok: input.basicsOk,
        },
        {
            labelKey: 'organizer.setup.checkTickets',
            bodyKey: input.ticketCount > 0
                ? 'organizer.setup.checkTicketsOk'
                : 'organizer.setup.checkTicketsMissing',
            bodyParams: input.ticketCount > 0 ? { count: input.ticketCount } : undefined,
            ok: input.ticketCount > 0,
        },
        {
            labelKey: 'organizer.setup.checkAgenda',
            bodyKey: input.agendaCount > 0
                ? 'organizer.setup.checkAgendaOk'
                : 'organizer.setup.checkAgendaMissing',
            bodyParams: input.agendaCount > 0 ? { count: input.agendaCount } : undefined,
            ok: input.agendaCount > 0,
        },
        /*
         * MARKA SATIRI (referans satır 887) — GERÇEK DURUMA BAĞLI, sabit uyarı
         * DEĞİL. Üç hâli vardır ve üçü de zincirin hangi halkasından geldiğini
         * söyler: etkinliğin kendi logosu · kurumdan devralınan logo · logo yok.
         */
        {
            labelKey: 'organizer.setup.checkBrand',
            bodyKey: !brandOk
                ? 'organizer.setup.checkBrandMissing'
                : input.brand?.logoSource === 'event'
                    ? 'organizer.setup.checkBrandOwn'
                    : 'organizer.setup.checkBrandInherited',
            ok: brandOk,
        },
        {
            labelKey: 'organizer.setup.checkVerification',
            bodyKey: input.verificationBodyKey,
            ok: input.verificationOk,
        },
        {
            labelKey: 'organizer.setup.checkPublished',
            bodyKey: input.published
                ? 'organizer.setup.checkPublishedOk'
                : 'organizer.setup.checkPublishedMissing',
            ok: input.published,
        },
    ];
}
//# sourceMappingURL=event-setup.js.map